<div
  class="topbar-root"
  [class.sidebar-collapsed]="sidebarCollapsed"
  [class.admin-portal-topbar]="isAdminMode()">
  <!-- Left header section - same width as sidebar -->
  <div class="topbar-left-header">
    <div class="sidebar-controls">
      <button class="collapse-sidebar-btn" aria-label="Toggle Sidebar" (click)="toggleSidebar.emit()">
        <img src="assets/icons/menu_open.svg" alt="Toggle Sidebar" class="collapse-icon" [class.rotated]="sidebarCollapsed" />
      </button>
      <div class="topbar-brand">
        <a
          class="topbar-logo-link"
          [routerLink]="homeRouterLink()"
          aria-label="Home">
          <img [src]="branding.topbarLogoSrc()" [alt]="branding.topbarLogoAlt()" class="topbar-logo" />
        </a>
      </div>
    </div>
  </div>

  <aio-app-top-bar class="topbar-right-section" brand="" [showLogo]="false" [showMenu]="false">
    @if (isAdminMode()) {
      <div aioAppTopBarStart class="admin-breadcrumb">
        <span class="admin-breadcrumb-label">Admin Portal</span>
      </div>
    }
      <!-- Search icon - hidden for now -->
      <!-- <img src="assets/icons/topbarSearch.svg" alt="Search" class="topbar-icon" /> -->
      <!-- <app-notification-bell></app-notification-bell> -->
      <!-- Notification icon - hidden for now -->
      <!-- <img src="assets/icons/notification.svg" alt="Notifications" class="topbar-icon" /> -->
      @if (isAdminMode()) {
        <aio-button appearance="secondary" size="sm" class="topbar-exit-admin-btn" (pressed)="exitAdminPortal()">
          Exit Admin Portal
        </aio-button>
      }
      <!-- Paths are inlined so the icon inherits currentColor; the asset SVGs
           carry a fixed fill and would disappear against a dark topbar.
           On the admin bar this stays with the other icons, after Exit. -->
      <button
        type="button"
        class="topbar-theme-toggle"
        [attr.aria-label]="themeService.theme() === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
        [attr.aria-pressed]="themeService.theme() === 'dark'"
        (click)="toggleDarkMode()">
        @if (themeService.theme() === 'dark') {
          <svg viewBox="0 0 29 29" aria-hidden="true" fill="none">
            <path d="M14.5 20.64a6.14 6.14 0 1 0 0-12.27 6.14 6.14 0 0 0 0 12.27Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14.5 1v2.45M14.5 25.55V28M4.93 4.93l1.72 1.72M22.35 22.35l1.72 1.72M1 14.5h2.45M25.55 14.5H28M4.93 24.07l1.72-1.72M22.35 6.65l1.72-1.72" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        } @else {
          <svg viewBox="0 0 20 20" aria-hidden="true">
            <path d="M10.4346 18.8721C8.03105 18.8721 5.72596 17.9173 4.02642 16.2178C2.32687 14.5182 1.37207 12.2131 1.37207 9.80962C1.37207 6.13774 3.48145 2.84555 6.74746 1.42407C6.86257 1.3739 6.99011 1.35957 7.11348 1.38294C7.23685 1.40631 7.35032 1.46629 7.43911 1.55508C7.5279 1.64386 7.58788 1.75733 7.61125 1.8807C7.63462 2.00407 7.62028 2.13162 7.57012 2.24673C7.19512 3.10766 6.99707 4.2104 6.99707 5.43462C6.99707 9.74243 10.5018 13.2471 14.8096 13.2471C16.0338 13.2471 17.1365 13.0491 17.9975 12.6741C18.1126 12.6239 18.2401 12.6096 18.3635 12.6329C18.4869 12.6563 18.6003 12.7163 18.6891 12.8051C18.7779 12.8939 18.8379 13.0073 18.8612 13.1307C18.8846 13.2541 18.8703 13.3816 18.8201 13.4967C17.3986 16.7627 14.1064 18.8721 10.4346 18.8721Z" fill="currentColor" />
          </svg>
        }
      </button>
      <!-- <app-notification-bell></app-notification-bell> -->
      @if (showCrewAppLink()) {
        <a
          class="topbar-crew-link"
          href="https://crew.aio.build/login"
          target="_blank"
          rel="noopener noreferrer"
          title="Opens the Crew Companion app">
          Crew App ↗
        </a>
      }
      @if (showNotifications) {
        <app-notifications
          [showNotifications]="showNotifications">
        </app-notifications>
      }
      <div class="profile-icon-container" style="position: relative;">
        
        @if (userProfilePicture) {
          <div class="profile-picture" (click)="openProfileModal($event)" style="cursor:pointer;">
            <img [src]="userProfilePicture" [alt]="userName" />
          </div>
        } @else {
          <div class="profile-initials" (click)="openProfileModal($event)" style="cursor:pointer;">
            {{ userInitials }}
          </div>
        }
        @if (profileModalOpen()) {
          <app-profile-modal
            [initials]="userInitials"
            [name]="userName"
            [email]="userEmail"
            [role]="userRole"
            [profilePicture]="userProfilePicture"
            [iconPosition]="iconPosition()"
            [isAdminMode]="isAdminMode()"
            (signOut)="logout()"
            (closed)="closeProfileModal()"
            (profileSettings)="goToProfileSettings()"
            (adminPortal)="goToAdminPortal()"
            (exitAdminPortal)="exitAdminPortal()">
          </app-profile-modal>
        }
      </div>
  </aio-app-top-bar>
</div>
